var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z","fill":"#2D87F3","key":0}),React.createElement("path",{"d":"M8 11V8","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8 5H8.01","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Info.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Info;

Info.default = Info;
